import toast from "react-hot-toast";
import {
  assignUser,
  createGlb,
  createObject,
  createPhotography,
  objectConservationCreation,
  objectConservationStatus,
} from "../../../../api/actions/object";
import {
  clearAutoSavedFromIndexedDB,
  getAutoSavedFromIndexedDB,
} from "../../../../indexdb/autosaveIndex";
import { hasOtherFieldValue } from "../../../../pages/ObjectConservation/conservationUtils";
import { sendSessionClose } from "../sendSessionclose";

export const autoSaveDraftIfExists = async (
  setIsSaving,
  userData,
  setAutoSaveError,
  setSavedDataFromIndex,
  skipOnceRef,
  prevPathRef,
  currentPath
) => {
  if (skipOnceRef?.current) {
    await clearAutoSavedFromIndexedDB("digital");
    await clearAutoSavedFromIndexedDB("conservation");
    await clearAutoSavedFromIndexedDB("collection");

    skipOnceRef.current = false;
    prevPathRef.current = currentPath;
    return;
  }

  const savedDraft = await getAutoSavedFromIndexedDB("collection");
  const savedDigital = await getAutoSavedFromIndexedDB("digital");
  const savedConservation = await getAutoSavedFromIndexedDB("conservation");

  if (savedDraft) {
    setIsSaving({
      collection: true,
    });
    const data = savedDraft;
    data.collection_is_draft = true;
    data.prime_category = data.category;
    data.category = data.sub_category;
    if (data.attribute === null) delete data.attribute;
    if (data.category === "") delete data.category;
    if (data.original_location_room === "") delete data.original_location_room;
    if (!data.acquisition_method) delete data.acquisition_method;

    if (data?.transitlunitType) {
      data.transit_location_storage_unit = data.transitlunitType;
    } else if (data?.transitlsystemtype) {
      data.transit_location_storage_system = data.transitlsystemtype;
    } else if (data?.transitlRoom) {
      data.transit_location_room = data.transitlRoom;
    }

    if (data?.originalunitType) {
      data.original_location_storage_unit = data?.originalunitType;
    } else if (data?.originalsystemtype) {
      data.original_location_storage_system = data?.originalsystemtype;
    } else if (data?.originalRoom) {
      data.original_location_room = data?.originalRoom;
    }

    const newEntryImage = data?.ledger_entry_images?.filter(
      (liImage) => liImage?.entry_image
    );
    const newDimension = data?.dimensions?.filter(
      (liDimens) => liDimens?.dimension_name || liDimens?.dimension_value
    );

    if (
      data?.original_location_room &&
      data?.height &&
      data?.width &&
      data?.depth &&
      data?.reference_image &&
      data?.material?.length > 0 &&
      data?.object_name
    ) {
      data.collection_is_draft = false;
    } else {
      data.collection_is_draft = true;
    }
    if (data.period_start_date === "" || data.period_end_date === "") {
      delete data.period;
    }
    const objectSession = Number(localStorage.getItem("objectSession"));
    localStorage.removeItem("objectSession");
    const payload = {
      ...data,
      dimensions: newDimension,
      ledger_entry_images: [...newEntryImage].reverse(), // reversed only here
      session: objectSession,
    };

    createObject(payload)((res) => {
      if (res?.status) {
        const objectChanges = localStorage.getItem("objectChanges");
        localStorage.removeItem("objectChanges");
        if (payload.id) {
          sendSessionClose(
            "collection",
            objectSession,
            payload.id,
            objectChanges,
            userData.museum
          );
        }
        setIsSaving({
          collection: false,
        });
        const assignValue = data.assignValue;

        if (assignValue) {
          const newAssignValue = assignValue.id
            ? assignValue
            : { ...assignValue, id: res?.data?.id };
          assignUser(newAssignValue)((response) => {
            if (response?.status) {
            }
          });
        }
      } else {
        if (res?.status_code === 400 && res?.conflict) {
          setAutoSaveError(true);
          setSavedDataFromIndex({
            collection: payload,
          });
        }
        setIsSaving({
          collection: false,
        });
      }
    });

    await clearAutoSavedFromIndexedDB("collection");
  } else if (savedDigital) {
    setIsSaving({
      digital: true,
    });

    const digitalData = savedDigital;

    if (digitalData.images) {
      digitalData.images = digitalData.images.filter(
        (image) => image.images !== ""
      );
    }

    const isImage = localStorage.getItem("isImage");
    if (isImage) {
      if (digitalData?.filterAutosave) {
        digitalData.images = digitalData.images.filter(
          (filItem) => filItem.autosave
        );
      }
      localStorage.removeItem("isImage");
    }

    const newImageWithIndex = digitalData.images?.map((liImage, liIndex) => ({
      ...liImage,
      index: liIndex,
      image_changed: liImage?.image_changed === true ? true : false,
    }));

    if (digitalData?.acquisition_method === "") {
      delete digitalData?.acquisition_method;
    }

    digitalData.images = newImageWithIndex;
    delete digitalData.tags;
    delete digitalData.dimensions;
    delete digitalData.function_or_usages;

    const digitalSession = localStorage.getItem("digitalsession");
    const digitalChanges = localStorage.getItem("digitalchanges");
    digitalData.session = digitalSession;
    localStorage.removeItem("digitalsession");
    localStorage.removeItem("digitalchanges");
    setSavedDataFromIndex({
      digital: digitalData,
    });
    if (digitalData.object_id) {
      ////This code is to exclude glb data before giving into create object api/////
      const excludeKeys = [
        "object_id",
        "file",
        "image_id",
        "url",
        "image_position",
        "index",
        "image_changed",
      ];
      const createApiData = Object.fromEntries(
        Object.entries(digitalData).filter(
          ([Key]) => !excludeKeys.includes(Key)
        )
      );

      createPhotography({
        id: createApiData?.id,
        images: createApiData?.images,
        session: digitalSession,
      })((response) => {
        if (response?.status) {
          sendSessionClose(
            "digital",
            digitalSession,
            createApiData?.id,
            digitalChanges,
            userData.museum
          );
          if (digitalData.assignValue) {
            assignUser(digitalData.assignValue)((response) => {
              if (response?.status) {
              }
            });
          }
          const formData = new FormData();

          formData.append("id", digitalData.object_id);
          if (digitalData?.file) {
            formData.append("file", digitalData?.file);
          }
          if (digitalData?.image_id) {
            formData.append("image_id", digitalData?.image_id);
          }
          if (digitalData?.url) {
            formData.append("url", digitalData?.url);
          }
          formData.append("image_position", digitalData?.image_position);
          formData.append("image_changed", digitalData?.image_changed);

          createGlb(formData)((response) => {
            if (response?.status) {
              setIsSaving({
                digital: false,
              });
            } else {
              setIsSaving({
                digital: false,
              });
            }
          });
        } else {
          if (response?.status_code === 400 && response?.conflict) {
            setAutoSaveError(true);
            setSavedDataFromIndex({
              digital: digitalData,
            });
          }
        }
      });
    } else {
      createPhotography({
        id: digitalData?.id,
        images: digitalData?.images,
        session: digitalSession,
      })((response) => {
        if (response?.status) {
          sendSessionClose(
            "digital",
            digitalSession,
            digitalData?.id,
            digitalChanges,
            userData.museum
          );
          setIsSaving({
            digital: false,
          });
          if (digitalData.assignValue) {
            assignUser(digitalData.assignValue)((response) => {
              if (response?.status) {
              }
            });
          }
        } else {
          if (response?.status_code === 400 && response?.conflict) {
            setAutoSaveError(true);
            setSavedDataFromIndex({
              digital: digitalData,
            });
          }
          setIsSaving({
            digital: false,
          });
        }
      });
    }

    await clearAutoSavedFromIndexedDB("digital");
  } else if (savedConservation) {
    setIsSaving({
      conservation: true,
    });

    const conservationData = savedConservation;

    if (!conservationData.stability) {
      delete conservationData.stability;
    }
    const filteredProposedTreatment =
      conservationData?.proposed_treatment.filter((li) => {
        const hasImportantData = li?.degradation || li?.temp_id; // Check if degradation or temp_id exists

        const noDataPropose =
          li?.step &&
          li?.action === "" &&
          li?.is_completed === false &&
          li?.task === "" &&
          li?.status === "" &&
          !hasImportantData;

        return !noDataPropose;
      });

    const filterInvestigationDetails = (investigationDetails = []) => {
      if (!Array.isArray(investigationDetails)) return [];

      return investigationDetails
        .filter((item) => {
          return (
            item?.investigation_name?.trim() ||
            item?.result?.trim() ||
            item?.sample_details?.trim()
          );
        })
        .reverse();
    };

    const filterGraphicaldescription =
      conservationData?.graphical_represenatation?.filter(
        (filterItem) => filterItem?.image
      );

    conservationData.graphical_represenatation = filterGraphicaldescription;
    // conservationData.investigation_details = filteredInvestigationTreatment;
    conservationData.proposed_treatment = filteredProposedTreatment;
    conservationData.conservation_is_draft = true;

    const processStratigraphic = (stratigraphic = []) => {
      return [...stratigraphic]
        .map((layer) => {
          // filter & reverse details
          const filteredDetails = [...(layer?.assessment_details || [])]
            .filter((detail) => {
              return (
                detail?.description?.trim() ||
                detail?.location?.trim() ||
                detail?.details?.trim() ||
                detail?.degradation?.trim() ||
                (detail?.evidence_images || []).some((img) =>
                  img?.image?.trim()
                )
              );
            })
            .map((detail) => ({
              ...detail,
              evidence_images: [...(detail?.evidence_images || [])]
                .filter((img) => img?.image?.trim())
                .reverse(),
            }))
            .reverse();

          return {
            ...layer,
            assessment_details: filteredDetails,
          };
        })
        .filter((layer) => {
          const hasDetails = (layer?.assessment_details || []).length > 0;

          const hasOtherData =
            !!layer?.assessment_name ||
            !!layer?.assessment_materials ||
            !!layer?.assessment_stability ||
            layer?.assessment_is_emergency === true;

          // ❌ remove ONLY if no details AND no other meaningful data
          return hasDetails || hasOtherData;
        })
        .reverse();
    };

    const processProposedTreatment = (proposedTreatment = []) => {
      return [...proposedTreatment]
        .filter((treat) => {
          // Check if treatment has meaningful data
          const hasImportantData = treat?.degradation || treat?.temp_id;

          const noDataPropose =
            treat?.step &&
            treat?.action === "" &&
            treat?.is_completed === false &&
            treat?.task === "" &&
            treat?.status === "" &&
            !hasImportantData;

          return !noDataPropose; // keep only treatments with real data
        })
        .map((treat) => {
          const filteredLogs = [...(treat?.treatment_log || [])]
            .filter((log) => {
              const hasEvidence = (log?.evidence || []).some(
                (img) => img?.image?.trim() || img?.thumbnail?.trim()
              );

              // keep only if at least one field has data
              return log?.date?.trim() || log?.notes?.trim() || hasEvidence;
            })
            .map((log) => ({
              ...log,
              evidence: [...(log?.evidence || [])]
                .filter((img) => img?.image?.trim() || img?.thumbnail?.trim()) // filter empty images
                .reverse(),
            }))
            .reverse();

          return {
            ...treat,
            treatment_log: filteredLogs, // always keep the key, even if []
          };
        })
        .reverse(); // reverse tre
    };

    // 🔄 reverse proposed_treatment and its nested treatment_log → evidence

    const conservationSession = localStorage.getItem("conservationsession");
    const conservationChanges = localStorage.getItem("conservationchanges");

    const payload = {
      ...conservationData,
      investigation_details: filterInvestigationDetails(
        conservationData?.investigation_details
      ),
      graphical_represenatation:
        conservationData.graphical_represenatation.reverse(),
      stratigraphic_assessment: processStratigraphic(
        conservationData?.stratigraphic_assessment
      ),
      proposed_treatment: processProposedTreatment(
        conservationData?.proposed_treatment
      ),
      session: conservationSession,
      // you can add other reversals like graphical_represenatation if needed
    };
    localStorage.removeItem("conservationsession");
    localStorage.removeItem("conservationchanges");

    objectConservationCreation(payload)((response) => {
      if (response?.status) {
        sendSessionClose(
          "conservation",
          conservationSession,
          payload?.id,
          conservationChanges,
          userData.museum
        );
        if (
          conservationData?.stability ||
          conservationData?.is_emergency
          // &&
          // conservationData?.remarks
        ) {
          const currentStatus =
            conservationData?.object_details?.conservation_status;

          let nextStatus = currentStatus;

          // 🚫 once in conservation → locked forever
          if (currentStatus === "in_conservation") {
            nextStatus = "in_conservation";
          }

          // to_do → in_conditional_assessment
          else if (currentStatus === "to_do") {
            if (hasOtherFieldValue(conservationData)) {
              nextStatus = "in_conservation";
            } else if (
              conservationData?.remarks &&
              (conservationData?.stability || conservationData?.is_emergency)
            ) {
              nextStatus = "in_conditional_assessment";
            }
          }

          // in_conditional_assessment → in_conservation
          else if (
            currentStatus === "in_conditional_assessment" &&
            hasOtherFieldValue(conservationData)
          ) {
            nextStatus = "in_conservation";
          }
          if (nextStatus !== currentStatus) {
            objectConservationStatus({
              id: conservationData?.id,
              conservation_status: nextStatus,
            })((response) => {
              if (response?.status) {
                // success
              }
            });
          }
          setIsSaving({
            conservation: false,
          });
          // }
        } else {
          setIsSaving({
            conservation: false,
          });
        }
        if (conservationData.assignValue) {
          assignUser(conservationData.assignValue)((response) => {
            if (response?.status) {
              setIsSaving({
                conservation: false,
              });
            } else {
              setIsSaving({
                conservation: false,
              });
            }
          });
        }
      } else {
        if (response?.status_code === 400 && response?.conflict) {
          setAutoSaveError(true);
          setSavedDataFromIndex({
            conservation: payload,
          });
        }
        if (!response?.conflict) {
          toast.error(response?.message, {
            style: {
              maxWidth: "500px",
              whiteSpace: "pre-wrap", // allows multiline text
              wordBreak: "break-word", // long words wrap
              height: "auto",
              padding: "12px 16px",
            },
          });
        }
        setIsSaving({
          conservation: false,
        });
      }
    });

    await clearAutoSavedFromIndexedDB("conservation");
  }
};
